document.addEventListener('DOMContentLoaded', () => {

    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
        iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
        iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
        shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
    });

    const createDebounce = (func, wait) => {
        let timeout;
        const debounced = function (...args) {
            const context = this;
            const later = () => {
                timeout = null;
                func.apply(context, args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
        debounced.cancel = () => {
            clearTimeout(timeout);
            timeout = null;
        };
        return debounced;
    };

    const getIcon = (name) => {
        const iconClasses = {
            Clock: 'icon-bus-clock',
            Phone: 'icon-phone',
            Globe: 'icon-web',
            Search: 'icon-search',
            Clear: 'icon-cancel',
            List: 'icon-sample-list',
            GuideFax: 'icon-guide-fax'
        };

        const iconClass = iconClasses[name];

        if (iconClass) {
            return `<i class="icon ${iconClass}"></i>`;
        }

        const svgIcons = {
            LocateFixed: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="2" x2="5" y1="12" y2="12"/><line x1="19" x2="22" y1="12" y2="12"/><line x1="12" x2="12" y1="2" y2="5"/><line x1="12" x2="12" y1="19" y2="22"/><circle cx="12" cy="12" r="7"/><circle cx="12" cy="12" r="3"/></svg>',
            Map: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>'
        };

        return svgIcons[name] || '';
    };

    const createCustomIcon = (unit, isSelected) => {
        const size = isSelected ? 44 : 36;
        const bgColor = isSelected ? '#00384D' : '#336071';
        const borderColor = isSelected ? '#0077B6' : '#FFFFFF';
        const borderWidth = isSelected ? 4 : 3;

        return L.divIcon({
            html: `<div style="width: ${size}px; height: ${size}px; background-color: ${bgColor}; border-radius: 50%; border: ${borderWidth}px solid ${borderColor}; display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);">
                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <g transform="translate(0, 1.5)">
                       <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" fill="none"/>
                       <circle cx="12" cy="10" r="3" fill="none"/>
                    </g>
                 </svg>
               </div>`,
            className: '',
            iconSize: [size, size],
            iconAnchor: [size / 2, size / 2],
            popupAnchor: [0, -(size / 2)]
        });
    };

    const renderPhone = (phone) => {
        if (!phone) return '';
        const parsePhonePart = (part) => {
            const trimmedPart = part.trim();
            if (!trimmedPart) return '';
            const phoneRegex = /([\d\s\+\(\)-]{6,})(.*)/;
            const match = trimmedPart.match(phoneRegex);
            if (match) {
                const numberDisplay = match[1].trim();
                const description = match[2].trim();
                const telLink = numberDisplay.replace(/[^\d+]/g, '');
                const descriptionHtml = description ? `<span class="cg-map-phone-description"> ${description}</span>` : '';
                return `<a href="tel:${telLink}" onclick="event.stopPropagation()">${numberDisplay}</a>${descriptionHtml}`;
            }
            const fallbackTelLink = trimmedPart.replace(/[^\d+]/g, '');
            return `<a href="tel:${fallbackTelLink}" onclick="event.stopPropagation()">${trimmedPart}</a>`;
        };
        return phone.split(',').map(p => parsePhonePart(p)).join('<br>');
    };

    const renderContactInfo = (unit, context = 'list') => {
        const items = [];
        let itemClass = 'cg-map-contact-item';
        if (context === 'popup' || context === 'bottomSheet') {
            itemClass = 'cg-map-popup-contact-item';
        }
        const createItemHtml = (iconName, content, originalText) => {
            if (!originalText) return '';
            const hasMultipleLines = /(?<=\d),/.test(originalText) || (iconName === 'Phone' && originalText.includes(','));
            const finalClass = hasMultipleLines ? `${itemClass} is-multiline` : itemClass;
            return `<div class="${finalClass}">${getIcon(iconName)}<span>${content}</span></div>`;
        };
        if (unit.hours) {
            const hoursContent = unit.hours.replace(/(?<=\d),/g, '<br>');
            items.push(createItemHtml('Clock', hoursContent, unit.hours));
        }
        if (unit.phone) {
            const phoneContent = renderPhone(unit.phone);
            items.push(createItemHtml('Phone', phoneContent, unit.phone));
        }
        if (unit.website) {
            const websiteUrl = unit.website.startsWith('http') ? unit.website : `https://${unit.website}`;
            const websiteContent = `<a href="${websiteUrl}" target="_blank" rel="noopener noreferrer" onclick="event.stopPropagation()">${unit.website}<span class="sr-only"> - otworzy się w nowej karcie</span></a>`;
            items.push(createItemHtml('Globe', websiteContent, unit.website));
        }
        if (items.length === 0) return '';
        let containerClass = 'cg-map-contact-info';
        if (context === 'popup') {
            containerClass = 'cg-map-popup-contact';
        } else if (context === 'bottomSheet') {
            containerClass = 'cg-map-bottom-sheet-contact';
        }
        if (unit.info) {
            items.push(createItemHtml('GuideFax', unit.info, unit.info));
        }
        return `<div class="${containerClass}">${items.join('')}</div>`;
    };

    class WroclawMap {
        constructor(mapId, inputUnits) {
            this.mapId = mapId;
            this.allUnits = this.validateAndFilterUnits(inputUnits);
            this.filteredUnits = [...this.allUnits];
            this.selectedUnit = null;
            this.searchQuery = '';
            this.isMobile = window.innerWidth < 768;
            this.showMobileList = true;
            this.container = document.getElementById(mapId);
            this.map = null;
            this.markerClusterGroup = null;
            this.markerRefs = {};
            this.BOTTOM_SHEET_ANIMATION_DURATION = 300;
            this.debouncedSearch = createDebounce(this.executeSearch.bind(this), 300);
            this.init();
        }

        isValidCoordinate(lat, lng) {
            const numLat = parseFloat(lat);
            const numLng = parseFloat(lng);
            return !isNaN(numLat) && !isNaN(numLng) && numLat >= -90 && numLat <= 90 && numLng >= -180 && numLng <= 180;
        }

        validateAndFilterUnits(units) {
            if (!Array.isArray(units)) return [];
            return units.filter(unit => {
                if (this.isValidCoordinate(unit.lat, unit.lng)) {
                    unit.lat = parseFloat(unit.lat);
                    unit.lng = parseFloat(unit.lng);
                    return true;
                } else {
                    return false;
                }
            });
        }

        init() {
            if (!this.container) return;
            if (this.allUnits.length === 0) {
                this.container.innerHTML = '<div style="padding: 1rem; text-align: center; color: #6B7280;"><p>Brak danych lokalizacyjnych.</p></div>';
                return;
            }

            const selectableOnLoadUnits = this.allUnits.filter(unit => unit.pinStatus !== 'hidden');
            if (selectableOnLoadUnits.length === 1) {
                this.selectedUnit = selectableOnLoadUnits[0];
            }

            if (this.allUnits.length === 1) {
                this.showMobileList = false;
            }

            this.createDOMStructure();
            this.initMap();
            this.setupEventListeners();
            this.render();
        }

        createDOMStructure() {
            this.container.innerHTML = '';
            const sidebar = document.createElement('div');
            sidebar.className = 'cg-map-sidebar';
            sidebar.innerHTML = `
            <div class="cg-map-header">
                <h2>Jednostki urzędowe</h2>
                <div class="search-container"></div>
                <p class="cg-map-desktop-results-count"></p>
            </div>
            <div class="cg-map-list-container" role="listbox"></div>
        `;
            this.sidebar = sidebar;
            this.searchContainer = sidebar.querySelector('.search-container');
            this.listRoot = sidebar.querySelector('.cg-map-list-container');

            const mainPanel = document.createElement('section');
            mainPanel.className = 'cg-map-main-panel';
            mainPanel.innerHTML = `
             <div class="cg-map-root-wrapper" style="width: 100%; height: 100%;">
                <div id="${this.mapId}-map-root" style="width: 100%; height: 100%;"></div>
             </div>
        `;
            this.mainPanel = mainPanel;
            this.mapRootWrapper = mainPanel.querySelector('.cg-map-root-wrapper');
            this.mapRoot = mainPanel.querySelector(`#${this.mapId}-map-root`);

            const mobileView = document.createElement('div');
            mobileView.className = 'cg-map-mobile-view';
            this.mobileViewRoot = mobileView;

            if (this.allUnits.length > 1) {
                this.container.append(sidebar, mainPanel, mobileView);
            } else {
                this.container.classList.add('cg-map-single-unit-view');
                this.container.append(mainPanel, mobileView);
            }
        }

        initMap() {
            const defaultCenter = [51.1079, 17.0385];
            this.map = L.map(this.mapRoot, {
                center: defaultCenter,
                zoom: 13,
                scrollWheelZoom: true,
            });
            L.tileLayer('https://maps.dev.wroclaw.pl/hot/{z}/{x}/{y}.png', {
                attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            }).addTo(this.map);

            this.markerClusterGroup = L.markerClusterGroup({
                showCoverageOnHover: false,
                spiderfyOnMaxZoom: true,
                maxClusterRadius: 50,
                iconCreateFunction: (cluster) => {
                    const count = cluster.getChildCount();
                    const size = 44;
                    const bgColor = '#336071';
                    const borderColor = '#FFFFFF';
                    const borderWidth = 3;

                    return L.divIcon({
                        html: `<div style="width: ${size}px; height: ${size}px; background-color: ${bgColor}; border-radius: 50%; border: ${borderWidth}px solid ${borderColor}; display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1); color: #FFFFFF; font-size: 18px; font-weight: 600; font-family: inherit; line-height: 1;">
                                 ${count}
                               </div>`,
                        className: 'cg-custom-cluster',
                        iconSize: [size, size],
                        iconAnchor: [size / 2, size / 2]
                    });
                }
            });
            this.map.addLayer(this.markerClusterGroup);

            this.map.on('click', () => this.handleUnitDeselect());
            this.renderMapMarkers();
            this.centerMapOnLoad();
        }

        centerMapOnLoad() {
            setTimeout(() => {
                if (!this.map) return;
                if (this.allUnits.length === 0) return;

                if (this.selectedUnit) {
                    this.updateMarkerState(this.selectedUnit, true);
                    this.executeCentering(this.selectedUnit, 16);
                } else {
                    const bounds = L.latLngBounds(this.allUnits.map(o => [o.lat, o.lng]));
                    this.executeFitBounds(bounds.pad(0.1));
                }
            }, 300);
        }

        setupEventListeners() {
            window.addEventListener('resize', createDebounce(() => {
                const wasMobile = this.isMobile;
                this.isMobile = window.innerWidth < 768;
                if (wasMobile !== this.isMobile) {
                    if (this.selectedUnit) {
                        const marker = this.markerRefs[this.selectedUnit.id];
                        if (marker && marker.getPopup()) {
                            marker.closePopup();
                            marker.unbindPopup();
                        }
                    }
                    this.render();
                    if (this.selectedUnit) {
                        if (!this.isMobile) {
                            const marker = this.markerRefs[this.selectedUnit.id];
                            if (marker) {
                                const details = marker.popupDetails;
                                if (details) {
                                    marker.bindPopup(details.content, details.options);
                                }
                                if (this.markerClusterGroup) {
                                    if (marker._map) {
                                        if (this.selectedUnit?.id === this.selectedUnit.id && marker.getPopup()) {
                                            marker.openPopup();
                                        }
                                    } else {
                                        this.markerClusterGroup.zoomToShowLayer(marker, () => {
                                            setTimeout(() => {
                                                if (marker._map && marker.getPopup()) marker.openPopup();
                                            }, 0);
                                        });
                                    }
                                }
                            }
                        }
                        this.centerMapOnUnit(this.selectedUnit, true);
                    }
                }
            }, 200));
            const accordionItem = this.container.closest('.acordion__item');
            if (accordionItem) {
                const accordionToggle = accordionItem.querySelector('.acordion__headingBox');
                if (accordionToggle) {
                    accordionToggle.addEventListener('click', () => {
                        this.centerMapOnLoad();
                    });
                }
            }
        }

        render() {
            if (!this.map) return;
            if (this.allUnits.length === 1) {
                if (this.isMobile) {
                    this.renderMobileView();
                } else {
                    this.mainPanel.style.display = 'flex';
                    if (this.mapRoot.parentElement !== this.mapRootWrapper) {
                        this.mapRootWrapper.appendChild(this.mapRoot);
                    }
                }
            } else if (this.isMobile) {
                this.renderMobileView();
            } else {
                this.renderDesktopView();
            }
            this.map.invalidateSize();
        }

        renderDesktopView() {
            if (this.mapRoot.parentElement !== this.mapRootWrapper) {
                this.mapRootWrapper.appendChild(this.mapRoot);
            }
            this.renderSearchOrLocate(this.searchContainer);
            this.renderUnitList(this.listRoot);
            this.updateResultCounts();
        }

        renderMobileView() {
            this.mobileViewRoot.innerHTML = '';
            if (this.showMobileList) {
                const listWrapper = document.createElement('div');
                listWrapper.className = 'cg-map-mobile-list-wrapper';
                const header = document.createElement('div');
                header.className = 'cg-map-header';
                const mobileHeaderActions = document.createElement('div');
                mobileHeaderActions.className = 'cg-map-mobile-header-actions';
                mobileHeaderActions.innerHTML = `
                <div data-id="mobile-results-count">Wyświetlono: <strong>${this.filteredUnits.length}</strong></div>
                <button class="cg-map-mobile-toggle-btn">${getIcon('Map')} Mapa</button>
                `;
                mobileHeaderActions.querySelector('button').addEventListener('click', () => {
                    this.showMobileList = false;
                    this.render();
                    if (this.selectedUnit) {
                        this.centerMapOnUnit(this.selectedUnit, true);
                    } else {
                        this.centerMapOnFiltered();
                    }
                });
                header.appendChild(mobileHeaderActions);
                this.renderSearchOrLocate(header);
                const mobileListContainer = document.createElement('div');
                mobileListContainer.className = 'cg-map-list-container';
                mobileListContainer.setAttribute('role', 'listbox');
                listWrapper.appendChild(header);
                listWrapper.appendChild(mobileListContainer);
                this.mobileViewRoot.appendChild(listWrapper);
                this.renderUnitList(mobileListContainer);
            } else {
                const mapWrapper = document.createElement('div');
                mapWrapper.className = 'cg-map-mobile-map-wrapper';
                const header = document.createElement('div');
                header.className = 'cg-map-header';
                const mobileHeaderActions = document.createElement('div');
                mobileHeaderActions.className = 'cg-map-mobile-header-actions';
                let headerContent = `<div data-id="mobile-results-count">Wyświetlono: <strong>${this.filteredUnits.length}</strong></div>`;
                if (this.allUnits.length > 1) {
                    headerContent += `<button class="cg-map-mobile-toggle-btn">${getIcon('List')} Lista</button>`;
                }
                mobileHeaderActions.innerHTML = headerContent;

                const toggleBtn = mobileHeaderActions.querySelector('.cg-map-mobile-toggle-btn');
                if (toggleBtn) {
                    toggleBtn.addEventListener('click', () => {
                        this.showMobileList = true;
                        this.render();
                    });
                }
                header.appendChild(mobileHeaderActions);
                this.renderSearchOrLocate(header);
                mapWrapper.appendChild(header);
                const mobileMapContainer = document.createElement('div');
                mobileMapContainer.className = 'cg-map-mobile-map-container';
                mapWrapper.appendChild(mobileMapContainer);
                this.mobileViewRoot.appendChild(mapWrapper);
                mobileMapContainer.appendChild(this.mapRoot);
                this.renderMobileBottomSheet();
            }
            this.updateResultCounts();
        }

        renderSearchOrLocate(container) {
            let searchOrLocateContainer = container.querySelector('.search-or-locate-container');
            if (!searchOrLocateContainer) {
                searchOrLocateContainer = document.createElement('div');
                searchOrLocateContainer.className = 'search-or-locate-container';
                container.appendChild(searchOrLocateContainer);
            }
            searchOrLocateContainer.innerHTML = '';
            if (this.allUnits.length <= 1) return;

            const wrapper = document.createElement('div');
            wrapper.className = 'cg-map-search-wrapper';

            if (this.allUnits.length < 10) {
                wrapper.innerHTML = `
                <button class="cg-map-locate-btn">
                    ${getIcon('LocateFixed')}
                    <span>Znajdź najbliżej mnie</span>
                </button>
            `;
                wrapper.querySelector('button').addEventListener('click', () => this.findNearestUnit());
            } else {
                wrapper.innerHTML = `
                <label for="${this.mapId}-search-input" class="sr-only">Wyszukaj</label>
                <div class="cg-map-search-icon">${getIcon('Search')}</div>
                <input id="${this.mapId}-search-input" type="text" placeholder="Szukaj..." class="cg-map-search-input" value="${this.searchQuery}">
                <button class="cg-map-clear-btn" style="display: ${this.searchQuery ? 'flex' : 'none'}" aria-label="Wyczyść">${getIcon('Clear')}</button>
            `;
                wrapper.querySelector('input').addEventListener('input', (e) => this.handleSearchInput(e.target.value, false));
                wrapper.querySelector('button').addEventListener('click', () => this.handleSearchInput('', true));
            }

            searchOrLocateContainer.appendChild(wrapper);

            const statusText = document.createElement('div');
            statusText.className = 'cg-map-location-status';
            searchOrLocateContainer.appendChild(statusText);
        }

        updateLocationStatus(msg) {
            const statusEls = this.container.querySelectorAll('.cg-map-location-status');
            statusEls.forEach(el => {
                if (msg) {
                    el.textContent = msg;
                    el.classList.add('is-visible');
                } else {
                    el.textContent = '';
                    el.classList.remove('is-visible');
                }
            });
        }

        handleSearchInput(query, immediate = false) {
            this.searchQuery = query;
            this.syncSearchUI();
            if (immediate) {
                this.debouncedSearch.cancel();
                this.executeSearch(query);
            } else {
                this.debouncedSearch(query);
            }
        }

        executeSearch(query) {
            const lowerCaseQuery = query.toLowerCase().trim();
            this.filteredUnits = this.allUnits.filter(o =>
                (o.name || '').toLowerCase().includes(lowerCaseQuery) ||
                (o.address || '').toLowerCase().includes(lowerCaseQuery) ||
                (o.type || '').toLowerCase().includes(lowerCaseQuery)
            );
            if (this.selectedUnit && !this.filteredUnits.some(u => u.id === this.selectedUnit.id)) {
                this.handleUnitDeselect();
            }
            this.renderMapMarkers();
            const listContainer = this.getCurrentListContainer();
            if (listContainer) this.renderUnitList(listContainer);
            this.updateResultCounts();
            if ((!this.isMobile || (this.isMobile && !this.showMobileList)) && !this.selectedUnit) {
                this.centerMapOnFiltered();
            }
        }

        renderUnitList(container) {
            if (!container) return;
            container.innerHTML = '';
            if (this.filteredUnits.length === 0) {
                container.innerHTML = '<div style="padding: 1rem; text-align: center; color: #6B7280;"><p>Nie znaleziono jednostek.</p></div>';
                return;
            }
            const fragment = document.createDocumentFragment();
            this.filteredUnits.forEach(unit => {
                const card = document.createElement('div');
                card.className = 'cg-map-unit-card';
                card.dataset.unitId = unit.id;
                card.tabIndex = 0;
                card.setAttribute('role', 'option');
                const contactHTML = renderContactInfo(unit, 'list');
                const isIOS = /iPod|iPhone|iPad/.test(navigator.platform);
                const isMac = /Mac/.test(navigator.platform);
                const fullAddress = `${unit.address}, Wrocław`;
                const encodedAddress = encodeURIComponent(fullAddress);
                let mapUrl = isIOS ? `maps://?q=${encodedAddress}` : (isMac ? `http://maps.apple.com/?q=${encodedAddress}` : `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`);
                card.innerHTML = `
                <div class="cg-map-card-content">
                    <p class="cg-map-unit-name">
                        <a href="jednostka/${unit.alias}" onclick="event.stopPropagation()" tabindex="-1">${unit.name}</a>
                    </p>
                    <span class="cg-map-unit-type" title="${unit.alt}">${unit.type}</span>
                    <p class="cg-map-address-wrapper"><a href="${mapUrl}" class="cg-map-unit-address" target="_blank" rel="noopener noreferrer">${unit.address}<span class="sr-only"> - otworzy się w nowej karcie</span></a></p>
                    ${contactHTML}
                </div>
            `;
                card.addEventListener('click', () => this.handleUnitSelect(unit));
                card.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.handleUnitSelect(unit);
                    }
                });
                fragment.appendChild(card);
            });
            container.appendChild(fragment);
            this.updateSelectedUnitListVisuals(null);
        }

        renderMapMarkers() {
            if (this.markerClusterGroup) {
                this.markerClusterGroup.clearLayers();
            }
            this.markerRefs = {};

            const markersToAdd = [];

            this.filteredUnits.forEach(unit => {
                const isSelected = this.selectedUnit?.id === unit.id;
                const marker = L.marker([unit.lat, unit.lng], {
                    icon: createCustomIcon(unit, isSelected),
                    alt: unit.name,
                    title: unit.name,
                    zIndexOffset: isSelected ? 1000 : 0
                });

                marker.on('click', (e) => {
                    L.DomEvent.stop(e);
                    this.handleUnitSelect(unit);
                });

                const contactHTML = renderContactInfo(unit, 'popup');
                const isIOS = /iPod|iPhone|iPad/.test(navigator.platform);
                const isMac = /Mac/.test(navigator.platform);
                const fullAddress = `${unit.address}, Wrocław`;
                const encodedAddress = encodeURIComponent(fullAddress);
                let mapUrl = isIOS ? `maps://?q=${encodedAddress}` : (isMac ? `http://maps.apple.com/?q=${encodedAddress}` : `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`);
                const popupContent = `
                <div class="cg-map-popup-content">
                    <p class="cg-map-popup-name"><a href="jednostka/${unit.alias}">${unit.name}</a></p>
                    <span class="cg-map-unit-type" title="${unit.alt}">${unit.type}</span>
                    <p class="cg-map-address-wrapper"><a href="${mapUrl}" class="cg-map-popup-address" target="_blank" rel="noopener noreferrer">${unit.address}<span class="sr-only"> - otworzy się w nowej karcie</span></a></p>
                    ${contactHTML}
                </div>`;
                marker.popupDetails = {
                    content: popupContent,
                    options: {closeButton: true, minWidth: 240, autoPanPaddingTopLeft: [40, 20]}
                };

                markersToAdd.push(marker);
                this.markerRefs[unit.id] = marker;
            });

            if (this.markerClusterGroup) {
                this.markerClusterGroup.addLayers(markersToAdd);
            }
        }

        renderMobileBottomSheet() {
            const mapContainer = this.mobileViewRoot.querySelector('.cg-map-mobile-map-container');
            if (!mapContainer) return;
            const existingSheet = mapContainer.querySelector('.cg-map-mobile-bottom-sheet');
            if (existingSheet) existingSheet.remove();
            if (!this.selectedUnit) return;
            const unit = this.selectedUnit;
            const sheet = document.createElement('div');
            sheet.className = 'cg-map-mobile-bottom-sheet';
            const contactHTML = renderContactInfo(unit, 'bottomSheet');
            const isIOS = /iPod|iPhone|iPad/.test(navigator.platform);
            const isMac = /Mac/.test(navigator.platform);
            const fullAddress = `${unit.address}, Wrocław`;
            const encodedAddress = encodeURIComponent(fullAddress);
            let mapUrl = isIOS ? `maps://?q=${encodedAddress}` : (isMac ? `http://maps.apple.com/?q=${encodedAddress}` : `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`);
            sheet.innerHTML = `
            <div class="cg-map-bottom-sheet-header">
                <div class="cg-map-bottom-sheet-title-group">
                    <p class="cg-map-bottom-sheet-name"><a href="jednostka/${unit.alias}">${unit.name}</a></p>
                    <span class="cg-map-bottom-sheet-unit-type" title="${unit.alt}">${unit.type}</span>
                </div>
                <button class="cg-map-bottom-sheet-close" aria-label="Zamknij">${getIcon('Clear')}</button>
            </div>
            <p class="cg-map-address-wrapper"><a href="${mapUrl}" class="cg-map-bottom-sheet-address" target="_blank" rel="noopener noreferrer">${unit.address}<span class="sr-only"> - otworzy się w nowej karcie</span></a></p>
            ${contactHTML}
        `;
            sheet.querySelector('.cg-map-bottom-sheet-close').addEventListener('click', () => this.handleUnitDeselect());
            mapContainer.appendChild(sheet);
            requestAnimationFrame(() => {
                setTimeout(() => {
                    sheet.classList.add('is-visible');
                }, 10);
            });
        }

        handleUnitSelect(unit) {
            const lastSelectedUnit = this.selectedUnit;
            let isViewSwitch = false;

            if (lastSelectedUnit?.id === unit.id) {
                this.centerMapOnUnit(unit, false);
                return;
            }

            this.selectedUnit = unit;
            this.updateMarkerState(lastSelectedUnit, false);
            this.updateMarkerState(unit, true);

            if (this.isMobile) {
                if (this.showMobileList) {
                    this.showMobileList = false;
                    isViewSwitch = true;
                    this.render();
                } else {
                    this.renderMobileBottomSheet();
                }
                this.centerMapOnUnit(unit, isViewSwitch);
            } else {
                this.updateSelectedUnitListVisuals(lastSelectedUnit);
                this.centerMapOnUnit(unit, false);
            }
        }

        handleUnitDeselect() {
            const lastSelectedUnit = this.selectedUnit;
            if (!lastSelectedUnit) return;

            this.selectedUnit = null;
            this.updateMarkerState(lastSelectedUnit, false);

            if (this.isMobile) {
                const sheet = this.mobileViewRoot.querySelector('.cg-map-mobile-bottom-sheet.is-visible');
                if (sheet) {
                    sheet.classList.remove('is-visible');
                    setTimeout(() => {
                        if (sheet.parentElement) sheet.parentElement.removeChild(sheet);
                    }, this.BOTTOM_SHEET_ANIMATION_DURATION);
                }
            } else {
                this.updateSelectedUnitListVisuals(lastSelectedUnit);
            }
        }

        updateSelectedUnitListVisuals(lastSelectedUnit = null) {
            const listContainer = this.getCurrentListContainer();
            if (!listContainer) return;
            let prevCard = lastSelectedUnit ? listContainer.querySelector(`.cg-map-unit-card[data-unit-id="${lastSelectedUnit.id}"]`) : listContainer.querySelector('.cg-map-unit-card.selected');
            if (prevCard && prevCard.dataset.unitId != this.selectedUnit?.id) {
                this.styleCard(prevCard, false);
            }
            if (this.selectedUnit) {
                const newCard = listContainer.querySelector(`.cg-map-unit-card[data-unit-id="${this.selectedUnit.id}"]`);
                if (newCard) {
                    this.styleCard(newCard, true);
                    newCard.scrollIntoView({behavior: 'smooth', block: 'nearest'});
                }
            }
        }

        styleCard(card, isSelected) {
            card.classList.toggle('selected', isSelected);
            card.setAttribute('aria-selected', isSelected);
        }

        updateMarkerState(unit, isSelected) {
            if (!unit) return;
            const marker = this.markerRefs[unit.id];
            if (marker) {
                marker.setIcon(createCustomIcon(unit, isSelected));
                marker.setZIndexOffset(isSelected ? 1000 : 0);

                if (isSelected) {
                    if (!this.isMobile) {
                        const details = marker.popupDetails;
                        if (details && !marker.getPopup()) {
                            marker.bindPopup(details.content, details.options);
                            marker.on('popupclose', () => {
                                if (this.selectedUnit && this.selectedUnit.id === unit.id) {
                                    this.handleUnitDeselect();
                                }
                            });
                        }

                        if (this.markerClusterGroup) {
                            if (marker._map) {
                                if (this.selectedUnit?.id === unit.id && marker.getPopup()) {
                                    marker.openPopup();
                                }
                            } else {
                                this.markerClusterGroup.zoomToShowLayer(marker, () => {
                                    if (this.selectedUnit?.id === unit.id && marker._map && marker.getPopup()) {
                                        marker.openPopup();
                                    }
                                });
                            }
                        }
                    }
                } else {
                    marker.off('popupclose');
                    if (marker.getPopup()) {
                        marker.closePopup();
                        marker.unbindPopup();
                    }
                }
            }
        }

        centerMapOnUnit(unit, isViewSwitch = false) {
            if (!this.map || !unit) return;
            const mapSize = this.map.getSize();
            const padding = this.calculatePadding();
            const visualCenterPoint = L.point((mapSize.x - padding.paddingBottomRight[0] + padding.paddingTopLeft[0]) / 2, (mapSize.y - padding.paddingBottomRight[1] + padding.paddingTopLeft[1]) / 2);
            const visualCenterLatLng = this.map.containerPointToLatLng(visualCenterPoint);
            const unitLatLng = L.latLng(unit.lat, unit.lng);
            if (visualCenterLatLng.distanceTo(unitLatLng) < 10) return;

            const targetZoom = this.map.getZoom() < 15 ? 16 : this.map.getZoom();
            const initializationDelay = isViewSwitch ? 100 : 50;
            setTimeout(() => {
                if (this.map) this.map.invalidateSize();
                if (this.selectedUnit?.id !== unit.id) return;
                if (this.isMobile && !this.showMobileList) {
                    const sheet = this.mobileViewRoot.querySelector('.cg-map-mobile-bottom-sheet');
                    if (sheet) {
                        setTimeout(() => {
                            if (this.selectedUnit?.id === unit.id) this.executeCentering(unit, targetZoom);
                        }, this.BOTTOM_SHEET_ANIMATION_DURATION + 50);
                    } else {
                        this.executeCentering(unit, targetZoom);
                    }
                } else {
                    this.executeCentering(unit, targetZoom);
                }
            }, initializationDelay);
        }

        executeCentering(unit, targetZoom, retries = 3) {
            if (!this.map || !unit || !this.isValidCoordinate(unit.lat, unit.lng)) return;
            const mapSize = this.map.getSize();
            if (mapSize.x === 0 || mapSize.y === 0) {
                if (retries > 0) {
                    setTimeout(() => {
                        if (this.map) this.map.invalidateSize();
                        this.executeCentering(unit, targetZoom, retries - 1);
                    }, 100);
                }
                return;
            }

            const unitLatLng = L.latLng(unit.lat, unit.lng);
            const padding = this.calculatePadding(false);

            const finalZoom = this.map.getZoom() >= targetZoom ? this.map.getZoom() : targetZoom;

            const ptCenter = this.map.project(unitLatLng, finalZoom);
            const offsetX = (padding.paddingBottomRight[0] - padding.paddingTopLeft[0]) / 2;
            const offsetY = (padding.paddingBottomRight[1] - padding.paddingTopLeft[1]) / 2;
            const targetCenter = this.map.unproject(ptCenter.add(L.point(offsetX, offsetY)), finalZoom);

            this.map.flyTo(targetCenter, finalZoom, {animate: true, duration: 0.8});
        }

        executeFitBounds(bounds, paddingOptions = {}, retries = 3) {
            if (!this.map || !bounds || !bounds.isValid()) return;
            const mapSize = this.map.getSize();
            if (mapSize.x === 0 || mapSize.y === 0) {
                if (retries > 0) {
                    setTimeout(() => {
                        if (this.map) this.map.invalidateSize();
                        this.executeFitBounds(bounds, paddingOptions, retries - 1);
                    }, 100);
                }
                return;
            }
            this.map.flyToBounds(bounds, {animate: true, duration: 0.5, ...paddingOptions});
        }

        calculatePadding(asOptions = false) {
            const padding = {paddingTopLeft: [0, 0], paddingBottomRight: [0, 0]};
            if (this.isMobile && !this.showMobileList) {
                const sheet = this.mobileViewRoot.querySelector('.cg-map-mobile-bottom-sheet');
                if (sheet && sheet.offsetHeight > 0) {
                    padding.paddingBottomRight = [0, sheet.offsetHeight];
                }
            }
            return asOptions ? {
                paddingTopLeft: padding.paddingTopLeft,
                paddingBottomRight: padding.paddingBottomRight
            } : padding;
        }

        centerMapOnFiltered() {
            if (this.filteredUnits.length === 0 || !this.map) return;
            if (this.filteredUnits.length === 1) {
                const unit = this.filteredUnits[0];
                const targetZoom = this.map.getZoom() < 15 ? 16 : this.map.getZoom();
                this.executeCentering(unit, targetZoom);
                return;
            }
            const bounds = L.latLngBounds(this.filteredUnits.map(o => [o.lat, o.lng]));
            const paddingOptions = this.calculatePadding(true);
            this.executeFitBounds(bounds.pad(0.1), paddingOptions);
        }

        syncSearchUI() {
            const searchInput = this.container.querySelector('.cg-map-search-input');
            if (searchInput && searchInput.value !== this.searchQuery) {
                searchInput.value = this.searchQuery;
            }
            const clearBtn = this.container.querySelector('.cg-map-clear-btn');
            if (clearBtn) {
                clearBtn.style.display = this.searchQuery ? 'flex' : 'none';
            }
        }

        getCurrentListContainer() {
            if (this.isMobile) {
                return this.showMobileList ? this.mobileViewRoot.querySelector('.cg-map-list-container') : null;
            }
            return this.listRoot;
        }

        updateResultCounts() {
            const count = this.filteredUnits.length;
            this.container.querySelectorAll('[data-id="mobile-results-count"]').forEach(el => {
                el.innerHTML = `Wyświetlono: <strong>${count}</strong>`;
            });
            const desktopCountEl = this.container.querySelector('.cg-map-desktop-results-count');
            if (desktopCountEl) {
                if (this.allUnits.length > 1) {
                    desktopCountEl.innerHTML = `Wyświetlono: <strong>${count}</strong>`;
                    desktopCountEl.style.display = 'block';
                } else {
                    desktopCountEl.style.display = 'none';
                }
            }
        }

        findNearestUnit() {
            if (!navigator.geolocation) {
                this.updateLocationStatus('Geolokalizacja nie jest wspierana w Twojej przeglądarce.');
                return;
            }
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const userLatLng = L.latLng(position.coords.latitude, position.coords.longitude);
                    let nearestUnit = null;
                    let minDistance = Infinity;
                    this.allUnits.forEach(unit => {
                        const distance = userLatLng.distanceTo(L.latLng(unit.lat, unit.lng));
                        if (distance < minDistance) {
                            minDistance = distance;
                            nearestUnit = unit;
                        }
                    });

                    if (nearestUnit) {
                        if (this.searchQuery) this.handleSearchInput('', true);

                        const marker = this.markerRefs[nearestUnit.id];
                        if (this.markerClusterGroup && marker) {
                            const parent = this.markerClusterGroup.getVisibleParent(marker);

                            if (parent && parent.getChildCount && parent.getChildCount() > 1) {
                                this.handleUnitDeselect();
                                this.markerClusterGroup.zoomToShowLayer(marker);
                                this.updateLocationStatus('');
                                return;
                            }
                        }

                        this.handleUnitSelect(nearestUnit);
                        this.updateLocationStatus('');
                    } else {
                        this.updateLocationStatus('Nie znaleziono jednostek w pobliżu.');
                    }
                },
                (error) => {
                    switch (error.code) {
                        case 1:
                            this.updateLocationStatus('Lokalizacja zablokowana. Udostępnij ją w ustawieniach przeglądarki.');
                            break;
                        case 2:
                            this.updateLocationStatus('Informacje o lokalizacji są w tej chwili niedostępne.');
                            break;
                        case 3:
                            this.updateLocationStatus('Zbyt długi czas oczekiwania na lokalizację.');
                            break;
                        default:
                            this.updateLocationStatus('Wystąpił nieznany błąd podczas pobierania lokalizacji.');
                            break;
                    }
                }
            );
        }
    }

    window.initCgReactMap = (mapId) => {
        const mapData = window.mapInstancesData[mapId];
        if (mapData && mapData.units) {
            const container = document.getElementById(mapId);
            if (container && !container.dataset.mapInitialized) {
                new WroclawMap(mapId, mapData.units);
                container.dataset.mapInitialized = 'true';
            }
        }
    };

    if (window.mapInstancesData) {
        Object.keys(window.mapInstancesData).forEach(mapId => {
            if (document.getElementById(mapId)) {
                window.initCgReactMap(mapId);
            }
        });
    }
});